import DialogButton from './Button';
import DialogCodeInput from './CodeInput';
import DialogContainer from './Container';
import DialogDescription from './Description';
import DialogInput from './Input';
import DialogSwitch from './Switch';
import DialogTitle from './Title';

export default {
  Button: DialogButton,
  Container: DialogContainer,
  Description: DialogDescription,
  Input: DialogInput,
  CodeInput: DialogCodeInput,
  Switch: DialogSwitch,
  Title: DialogTitle,
};
